import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

/**
 * Eingabefeld für die externe Auftragsnummer.
 * Der Wert wird mit den Auftragsdaten übertragen und beim Import nach
 * Auftragskopf.AextNummer ("ext. Auf-Nr.") übernommen.
 */
@Component({
    selector: 'auftrag-ext-nummer-komponente',
    template: `
        <div class="section">
            <ion-item lines="none" class="ext-nummer-item">
                <ion-label position="stacked">{{ getEinstellung('Titel') || ('ExtNummer' | translate) }}</ion-label>
                <ion-input type="text"
                           [(ngModel)]="auftrag.AextNummer"
                           maxlength="50"
                           placeholder="{{ 'ExtNummerHierEingeben' | translate }}"
                           clearInput
                           (ionBlur)="onExtNummerGeaendert()"></ion-input>
            </ion-item>
        </div>
    `,
    styles: [`
    .ext-nummer-item {
        --padding-start: 0;
        --inner-padding-end: 0;
    }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragExtNummerComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private auftragService: AuftragService,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    async onExtNummerGeaendert() {
        await this.auftragService.speichereAuftrag(this.auftrag, { listItemAktualisieren: true });
    }
}
